module.exports = __webpack_public_path__ + "static/img/icon-4.fad1e61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-4.png
// module id = BiRF
// module chunks = 7